var exports = {
  "X7": "UserProfileBadges.module__containerModal___eUV5NW",
  "b1": "UserProfileBadges.module__containerInline___eUV5NW",
  "gB": "UserProfileBadges.module__moreBadges___eUV5NW",
  "j4": "UserProfileBadges.module__containerModalMobile___eUV5NW",
  "pP": "UserProfileBadges.module__containerModalDesktop___eUV5NW",
  "RS": "UserProfileBadges.module__containerPopout___eUV5NW",
  "Qk": "UserProfileBadges.module__badgeMobile___eUV5NW",
  "EJ": "UserProfileBadges.module__badgeDesktop___eUV5NW",
  "X8": "UserProfileBadges.module__sequenceBadge___eUV5NW",
  "Fi": "UserProfileBadges.module__sequenceBadgeMobile___eUV5NW",
  "Hd": "UserProfileBadges.module__sequenceBadgeDesktop___eUV5NW",
  "nf": "UserProfileBadges.module__link___eUV5NW",
  "$J": "UserProfileBadges.module__linkButton___eUV5NW",
  "tt": "UserProfileBadges.module__hoverCard___eUV5NW",
  "I": "UserProfileBadges.module__hoverCardIcon___eUV5NW",
  "Z3": "UserProfileBadges.module__hoverCardTitle___eUV5NW",
  "Ox": "UserProfileBadges.module__hoverCardDetail___eUV5NW",
  "SD": "UserProfileBadges.module__hoverCardSequence___eUV5NW",
};

module.exports = exports;
